export default __webpack_public_path__ + "static/media/Analytic.3445ec9f.svg";